module.exports = __webpack_public_path__ + "img/stickers-contrat-de-mariage.ace65b27.jpg";